import { CheckboxController } from './checkbox.controller';
import { CheckboxComponentProps } from './checkbox.model';

const Checkbox = (props: CheckboxComponentProps): JSX.Element => {
  return <CheckboxController {...props} />;
};
export default Checkbox;
